import { useEffect } from 'react';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600;700&family=Quicksand:wght@400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }

  body {
    font-family: 'Quicksand', sans-serif;
    color: #1a1a2e;
    overflow-x: hidden;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    background: #fff;
  }

  /* Fons de cada secció: colors PLANS i sòlids (sense degradats entre
     seccions). Cada bloc declara el seu propi color inline a App.jsx —
     és molt més robust que intentar fondre'ls, i evita els efectes
     estranys que apareixien amb els degradats llargs. */
  h1, h2, h3, .font-title {
    font-family: 'Fredoka', sans-serif;
    font-weight: 600;
  }
  button { font-family: 'Quicksand', sans-serif; }

  @keyframes fadeUp {
    from { opacity:0; transform:translateY(24px); }
    to   { opacity:1; transform:translateY(0); }
  }
  @keyframes fadeIn { from{opacity:0} to{opacity:1} }
  @keyframes scaleIn {
    from { opacity:0; transform:scale(0.9); }
    to   { opacity:1; transform:scale(1); }
  }
  @keyframes float {
    0%,100% { transform:translateY(0); }
    50%     { transform:translateY(-8px); }
  }

  .anim-fadeUp  { animation: fadeUp  0.7s cubic-bezier(0.22,1,0.36,1) both; }
  .anim-fadeIn  { animation: fadeIn  0.4s ease both; }
  .anim-scaleIn { animation: scaleIn 0.35s cubic-bezier(0.34,1.56,0.64,1) both; }

  .reveal {
    opacity:0; transform:translateY(20px) scale(0.97);
    transition: opacity 0.65s cubic-bezier(0.22,1,0.36,1),
                transform 0.65s cubic-bezier(0.22,1,0.36,1);
  }
  .reveal.visible { opacity:1; transform:translateY(0) scale(1); }

  /* Barra de progrés de scroll */
  .scroll-progress-fill { transition: width 0.12s linear; }

  /* Mosaic marquee — cinta contínua de fotos (pur CSS, molt eficient) */
  .marquee-wrap { display:flex; flex-direction:column; gap:0.7rem; }
  .marquee-row {
    overflow: hidden;
    padding: 10px 0;
    -webkit-mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
            mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
  }
  .marquee-track {
    display:flex; gap:0.85rem; width:max-content;
    animation: marquee-left var(--marquee-duration, 32s) linear infinite;
    will-change: transform;
  }
  .marquee-track.marquee-right { animation-name: marquee-right; }
  @keyframes marquee-left  { from { transform:translateX(0); }    to { transform:translateX(-50%); } }
  @keyframes marquee-right { from { transform:translateX(-50%); } to { transform:translateX(0); } }
  .marquee-photo {
    width:112px; height:112px; object-fit:cover; border-radius:18px; flex-shrink:0;
    border:3px solid #fff; box-shadow:0 6px 18px rgba(0,51,102,0.14);
    transition: transform 0.25s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.25s ease;
  }
  .marquee-photo:hover {
    transform: scale(1.14) rotate(-2deg);
    box-shadow: 0 16px 34px rgba(0,51,102,0.32);
    z-index: 5; position: relative;
  }

  /* Slider */
  .slider-track { display:flex; transition:transform 0.55s cubic-bezier(0.4,0,0.2,1); will-change:transform; }
  .slider-track img { width:100%; aspect-ratio:4/3; object-fit:cover; flex-shrink:0; }
  .slider-btn { opacity:0; transition:opacity 0.2s, transform 0.2s; }
  .slider-wrap:hover .slider-btn { opacity:1; }

  /* Dots */
  .dot { width:7px; height:7px; border-radius:50%; background:rgba(0,51,102,0.2); border:none; cursor:pointer; padding:0; transition:all 0.3s; }
  .dot.active { background:#003366; width:20px; border-radius:4px; }

  /* Acordió */
  .acordio-body { max-height:0; overflow:hidden; transition:max-height 0.4s cubic-bezier(0.4,0,0.2,1); }
  .acordio-body.open { max-height:2000px; }
  .fletxa { display:inline-block; transition:transform 0.3s cubic-bezier(0.4,0,0.2,1); }
  .fletxa.open { transform:rotate(180deg); }

  /* Boto admin */
  .boto-admin { transition:transform 0.2s, box-shadow 0.2s; }
  .boto-admin:hover { transform:scale(1.1) rotate(90deg); }

  /* Scrollbar */
  ::-webkit-scrollbar { width:5px; }
  ::-webkit-scrollbar-track { background:#f5f5f5; }
  ::-webkit-scrollbar-thumb { background:#003366; border-radius:3px; }

  @media (max-width:768px) {
    .hide-mobile { display:none !important; }
    .show-mobile { display:block !important; }
    .show-mobile-flex { display:flex !important; }
    .col-2 { grid-template-columns: 1fr !important; }
    .col-3 { grid-template-columns: 1fr !important; }
    .col-2-mobile { grid-template-columns: 1fr 1fr !important; }
    .mobile-center { text-align:center !important; }
    .mobile-pad { padding: 3rem 1.25rem !important; }
    .photo-collage { display:none !important; }
    .marquee-photo { width:88px; height:88px; }
  }

  @media (prefers-reduced-motion:reduce) {
    *, *::before, *::after {
      animation-duration:0.01ms !important;
      transition-duration:0.01ms !important;
    }
    .marquee-track { animation: none !important; }
  }
`;

export default function GlobalStyles() {
  useEffect(() => {
    const el = document.createElement('style');
    el.textContent = CSS;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);
  return null;
}